/**
 * Русская локализация каталога текстов для функции торговли
 * (`@gamecodex/world-ui` → `features/commerce`).
 *
 * Ключи соответствуют вызовам `t('commerce.*')` в React-компонентах функции.
 * Значения — точный оригинальный русский текст, извлечённый во время развёртывания i18n.
 */
export const commerceRu = {
  // DtrpgClaimPage.tsx
  'commerce.dtrpg.seoTitle': 'Требуй свою библиотеку',
  'commerce.dtrpg.seoDescription': 'Импортируй свою библиотеку DriveThruRPG и получи свои Grymwyrd PDF.',
  'commerce.dtrpg.heading': 'Требуй свою библиотеку',
  'commerce.dtrpg.intro':
    'Купил Grymwyrd на DriveThruRPG или поддержал кампанию? Войди по адресу электронной почты покупки, чтобы импортировать свою библиотеку и получить свои копии.',
  'commerce.dtrpg.sendLinkError': 'Сейчас не удаётся отправить ссылку входа. Попробуй ещё раз через минуту.',
  'commerce.dtrpg.checkInboxPrefix': 'Проверь входящие письма на',
  'commerce.dtrpg.checkInboxSuffix':
    'Если этот адрес поддерживал или покупал Grymwyrd, ссылка входа уже в пути — нажми на неё, чтобы вернуться сюда и получить свою библиотеку.',
  'commerce.dtrpg.linkAutoSignIn': 'Ссылка входит тебя автоматически — пароль не нужен.',
  'commerce.dtrpg.purchaseEmailLabel': 'Твой адрес электронной почты покупки / взноса',
  'commerce.dtrpg.sendingLink': 'Отправляю ссылку…',
  'commerce.dtrpg.emailLinkCta': 'Отправь мне ссылку входа',
  'commerce.dtrpg.signedInAs': 'Вошли как',
  'commerce.dtrpg.signOut': 'Выйти',
  'commerce.dtrpg.dtrpgEmailLabel': 'Адрес DriveThruRPG',
  'commerce.dtrpg.dtrpgEmailOptional': '(необязательно — если отличается от указанного выше)',
  'commerce.dtrpg.dtrpgEmailHelp': 'Мы используем его для сопоставления твоих покупок на DriveThruRPG при выдаче библиотеки.',
  'commerce.dtrpg.libraryHeading': 'Твоя библиотека Grymwyrd',
  'commerce.dtrpg.noTitles': 'Пока не настроено ни одного импортируемого издания.',
  'commerce.dtrpg.claimNotInLibrary':
    'Это издание ещё не в твоей библиотеке. Убедись, что использовал правильный адрес электронной почты покупки.',
  'commerce.dtrpg.claimSessionExpired': 'Твоя сессия истекла — войди ещё раз.',
  'commerce.dtrpg.claimError': 'Сейчас не удаётся получить это издание. Попробуй ещё раз.',
  'commerce.dtrpg.preparingCopy': 'Подготавливаю твою копию…',
  'commerce.dtrpg.download': 'Скачать',
  'commerce.dtrpg.preparing': 'Подготавливаю…',
  'commerce.dtrpg.claiming': 'Получаю…',
  'commerce.dtrpg.claim': 'Получить',

  // PaywallPrompt.tsx
  'commerce.paywall.checkoutFailed': 'Оплату не удалось открыть. Попробуй ещё раз позже.',
  'commerce.paywall.signInToPurchase': 'Войди, чтобы завершить эту покупку.',
  'commerce.paywall.vaultSealed': 'Хранилище торговца сейчас запечатано — попробуй ещё раз позже.',
  'commerce.paywall.signInToUnlock': 'Войти, чтобы разблокировать',
  'commerce.paywall.comingSoonTitle': 'Эта покупка скоро будет доступна',
  'commerce.paywall.priceComingSoon': '{price} — скоро',
  'commerce.paywall.comingSoon': 'Скоро',
  'commerce.paywall.openingVault': 'Открываю хранилище…',
  'commerce.paywall.unlockPrice': 'Разблокировать — {price}',
  'commerce.paywall.unlock': 'Разблокировать',

  // MarketplacePage.tsx
  'commerce.marketplace.installSuccess': 'Пак "{name}" установлен на твой стол.',
  'commerce.marketplace.installNotOwned': 'Ты ещё не обладаешь этим паком — покупка паков скоро будет доступна.',
  'commerce.marketplace.installHostOnly': 'Только хозяин стола может установить пак.',
  'commerce.marketplace.installError': 'Не удаётся установить этот пак. Попробуй ещё раз.',
  'commerce.marketplace.installed': 'Установлено',
  'commerce.marketplace.installing': 'Устанавливаю…',
  'commerce.marketplace.installOnTable': 'Установить на стол',
  'commerce.marketplace.seoTitle': 'Маркетплейс — Паки',
  'commerce.marketplace.seoDescription':
    'Просмотри и установи паки контента создателей — карты, сцены, раздаточные материалы и готовые наборы — на свои столы.',
  'commerce.marketplace.eyebrow': 'Маркетплейс',
  'commerce.marketplace.heading': 'Паки контента',
  'commerce.marketplace.intro':
    'Карты, сцены, раздаточные материалы и готовые наборы — установи их на свои столы в один клик.',
  'commerce.marketplace.installingOnto': 'Устанавливаю на стол {tableId}.',
  'commerce.marketplace.signInHeading': 'Войди, чтобы увидеть свои паки',
  'commerce.marketplace.signInBlurb': 'Каталог паков связан с твоей учётной записью создателя.',
  'commerce.marketplace.signIn': 'Войти',
  'commerce.marketplace.loading': 'Призываю твои паки…',
  'commerce.marketplace.noPacksHeading': 'Паков ещё нет',
  'commerce.marketplace.noPacksBlurb':
    'Ты ещё не опубликовал ни одного пака. Общедоступный маркетплейс для просмотра паков других создателей скоро откроется.',
  'commerce.marketplace.footer': 'Просмотр паков других создателей и платные паки уже в пути.',

  // SubscriberPerksPage.tsx
  'commerce.subscriber.perk1Title': 'Столы только для подписчиков',
  'commerce.subscriber.perk1Blurb': 'Присоединись к столам, которые твои любимые хозяева зарезервировали для подписчиков.',
  'commerce.subscriber.perk2Title': 'Ранний и эксклюзивный контент',
  'commerce.subscriber.perk2Blurb': 'Получай главы кампаний, сцены и раздаточные материалы раньше всех.',
  'commerce.subscriber.perk3Title': 'Значок подписчика',
  'commerce.subscriber.perk3Blurb': 'Знак статуса на твоём профиле и за столом.',
  'commerce.subscriber.seoTitle': 'Преимущества подписчика',
  'commerce.subscriber.seoDescription':
    'Стань подписчиком и получи доступ к эксклюзивным столам, раннему контенту и значку подписчика.',
  'commerce.subscriber.heading': 'Стань подписчиком',
  'commerce.subscriber.intro':
    'Поддержи хозяев и создателей, которых ты любишь — и открой преимущества, которые они зарезервировали для своего ближайшего круга.',
  'commerce.subscriber.activeHeading': 'Ты подписчик',
  'commerce.subscriber.activeBlurb':
    'Твои преимущества активны. Ищи герб подписчика на столах, к которым ты можешь присоединиться.',
  'commerce.subscriber.findTable': 'Найти стол подписчика',
  'commerce.subscriber.paywallTitle': 'Подписка Grymwyrd',
  'commerce.subscriber.paywallBlurb':
    'Открой столы только для подписчиков, ранний контент и свой значок подписчика.',
  'commerce.subscriber.paywallPrice': 'от $5/мес',

  // TicketCheckoutPage.tsx
  'commerce.ticket.checkoutFailed': 'Оплату не удалось открыть. Попробуй ещё раз позже.',
  'commerce.ticket.signInToBuy': 'Войди, чтобы купить место за этим столом.',
  'commerce.ticket.boxOfficeClosed': 'Касса сейчас закрыта — попробуй ещё раз позже.',
  'commerce.ticket.seoTitle': 'Купить место',
  'commerce.ticket.seoDescription': 'Зарезервируй своё место за столом с билетами.',
  'commerce.ticket.eyebrow': 'Стол с билетами',
  'commerce.ticket.heading': 'Зарезервируй своё место',
  'commerce.ticket.loading': 'Загружаю стол…',
  'commerce.ticket.notFoundHeading': 'Стол не найден',
  'commerce.ticket.notFoundBlurb': 'Этот стол может быть закрыт, или его двери никогда не открывались.',
  'commerce.ticket.backToLobby': 'Вернуться в вестибюль',
  'commerce.ticket.freeHeading': 'Этот стол свободен для присоединения',
  'commerce.ticket.freeBlurb': 'Билет не требуется — подтяни стул.',
  'commerce.ticket.goToLobby': 'Перейти в вестибюль',
  'commerce.ticket.untitledTable': 'Безымянный стол',
  'commerce.ticket.seatPrice': 'Цена места',
  'commerce.ticket.spectatorsNote': 'Зрители должны также иметь билет для этого стола.',
  'commerce.ticket.paymentReceived': 'Платёж получен — твоё место зарезервировано. Направляйся в вестибюль, чтобы занять его.',
  'commerce.ticket.signInToBuySeat': 'Войти, чтобы купить место',
  'commerce.ticket.openingBoxOffice': 'Открываю кассу…',
  'commerce.ticket.buySeatPrice': 'Купить место — {price}',
  'commerce.ticket.comingSoonTitle': 'Система билетов скоро будет доступна',
  'commerce.ticket.ticketingComingSoon': 'Система билетов скоро',
  'commerce.ticket.comingSoonFooter': 'Платные места уже почти готовы. Пока попроси свободное приглашение у хозяина.',

  // TipGoalManagerPage.tsx
  'commerce.tip.errHostOnlyGoal': 'Только хозяин стола может управлять целями.',
  'commerce.tip.errHostOnlyBounty': 'Только хозяин стола может управлять вознаграждениями.',
  'commerce.tip.errMaxGoal': 'Ты достиг максимального числа целей для этого стола.',
  'commerce.tip.errMaxBounty': 'Ты достиг максимального числа вознаграждений для этого стола.',
  'commerce.tip.errMissingGoal': 'В этой цели отсутствуют требуемые детали.',
  'commerce.tip.errMissingBounty': 'В этом вознаграждении отсутствуют требуемые детали.',
  'commerce.tip.errSignIn': 'Войди как хозяин, чтобы управлять этим столом.',
  'commerce.tip.errSaveFailedGoal': 'Не удаётся сохранить цель. Попробуй ещё раз.',
  'commerce.tip.errSaveFailedBounty': 'Не удаётся сохранить вознаграждение. Попробуй ещё раз.',
  'commerce.tip.goalValidation': 'Добавь название и положительную сумму цели.',
  'commerce.tip.goalAdded': 'Цель "{label}" добавлена.',
  'commerce.tip.goalLabelPlaceholder': 'Название цели (напр. Призови босса)',
  'commerce.tip.targetPlaceholder': 'Цель $',
  'commerce.tip.cuePlaceholder': 'Сигнал при достижении (напр. фанфара)',
  'commerce.tip.addGoal': 'Добавить цель',
  'commerce.tip.bountyValidation': 'Добавь название, положительную сумму и триггер.',
  'commerce.tip.bountyAdded': 'Вознаграждение "{label}" добавлено.',
  'commerce.tip.bountyLabelPlaceholder': 'Название вознаграждения (напр. Натуральная 20 спасает группу)',
  'commerce.tip.triggerPlaceholder': 'Триггер (напр. натуральная 20)',
  'commerce.tip.addBounty': 'Добавить вознаграждение',
  'commerce.tip.signInToManage': 'Войди, чтобы управлять этим столом.',
  'commerce.tip.bountyClaimed': 'Вознаграждение "{label}" получено.',
  'commerce.tip.seoTitle': 'Цели для чаевых и вознаграждения',
  'commerce.tip.seoDescription': 'Устанавливай цели чаевых и вознаграждения для своего стола.',
  'commerce.tip.backToLobby': 'Вернуться в вестибюль',
  'commerce.tip.heading': 'Цели для чаевых и вознаграждения',
  'commerce.tip.intro':
    'Устанавливай цели и вознаграждения для своего стола. Когда чаша переполнится, сигнал срабатывает для твоей аудитории. Отображение на трансляции обрабатывается твоим оверлеем трансляции.',
  'commerce.tip.loading': 'Читаю ведомость…',
  'commerce.tip.loadErrorTitle': 'Не удаётся загрузить ведомость',
  'commerce.tip.raisedSoFar': 'Собрано до сих пор:',
  'commerce.tip.tipGoalsHeading': 'Цели чаевых',
  'commerce.tip.noGoals': 'Целей ещё нет — добавь первую ниже.',
  'commerce.tip.reachedAria': 'достигнуто',
  'commerce.tip.bountiesHeading': 'Вознаграждения',
  'commerce.tip.noBounties': 'Вознаграждений ещё нет — добавь первое ниже.',
  'commerce.tip.whenLabel': '· когда: {trigger}',
  'commerce.tip.claimed': 'Получено',
  'commerce.tip.claimTitleReady': 'Отметить это вознаграждение как полученное',
  'commerce.tip.claimTitleNotFunded': 'Пока не финансировано',
  'commerce.tip.claim': 'Получить',
} as const
